/* eslint-disable sort-keys */
export const EMOJI_SIZE_CONFIG = {
  414: {
    large: {
      emojiSize: 28,
      size: 56,
    },
    small: {
      emojiSize: 24,
      size: 45,
    },
  },
  768: {
    large: {
      emojiSize: 36,
      size: 64,
    },
    small: {
      emojiSize: 24,
      size: 45,
    },
  },
  992: {
    large: {
      emojiSize: 64,
      size: 102,
    },
    small: {
      emojiSize: 36,
      size: 64,
    },
  },
  1366: {
    large: {
      emojiSize: 72,
      size: 120,
    },
    small: {
      emojiSize: 40,
      size: 72,
    },
  },
  Infinity: {
    large: {
      emojiSize: 80,
      size: 136,
    },
    small: {
      emojiSize: 48,
      size: 82,
    },
  },
};

export const EMOJI_POSITION_CONFIG = {
  414: {
    leftTop: {
      left: 1,
      top: 273,
    },
    leftMiddle: {
      left: 40,
      top: 323,
    },
    leftBottom: {
      left: -31,
      top: 340,
    },
    rightTop: {
      right: 1,
      top: 273,
    },
    rightMiddle: {
      right: 40,
      top: 323,
    },
    rightBottom: {
      right: -31,
      top: 340,
    },
  },
  768: {
    leftTop: {
      left: 1,
      top: 273,
    },
    leftMiddle: {
      left: 60,
      top: 323,
    },
    leftBottom: {
      left: -31,
      top: 340,
    },
    rightTop: {
      right: 1,
      top: 273,
    },
    rightMiddle: {
      right: 60,
      top: 323,
    },
    rightBottom: {
      right: -31,
      top: 340,
    },
  },
  992: {
    leftTop: {
      left: 24,
      top: 253,
    },
    leftMiddle: {
      left: 104,
      top: 320,
    },
    leftBottom: {
      left: -20,
      top: 346,
    },
    rightTop: {
      right: 24,
      top: 253,
    },
    rightMiddle: {
      right: 104,
      top: 320,
    },
    rightBottom: {
      right: -20,
      top: 346,
    },
  },
  1366: {
    leftTop: {
      left: 33,
      top: 230,
    },
    leftMiddle: {
      left: 139,
      top: 320,
    },
    leftBottom: {
      left: -24,
      top: 353,
    },
    rightTop: {
      right: 33,
      top: 230,
    },
    rightMiddle: {
      right: 139,
      top: 320,
    },
    rightBottom: {
      right: -24,
      top: 353,
    },
  },
  Infinity: {
    leftTop: {
      left: 33,
      top: 230,
    },
    leftMiddle: {
      left: 139,
      top: 320,
    },
    leftBottom: {
      left: -24,
      top: 353,
    },
    rightTop: {
      right: 33,
      top: 230,
    },
    rightMiddle: {
      right: 139,
      top: 320,
    },
    rightBottom: {
      right: -24,
      top: 353,
    },
  },
};
